var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceLaptop = function SvgDeviceLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.25 28.896a1.187 1.187 0 1 1 0 2.375H4.75a1.188 1.188 0 0 1 0-2.375zM28.896 11.083a.396.396 0 0 0-.396-.396h-19a.396.396 0 0 0-.396.396V23.75a.396.396 0 0 0 .396.396h19a.396.396 0 0 0 .396-.396zM31.27 23.75a2.77 2.77 0 0 1-2.771 2.77h-19a2.77 2.77 0 0 1-2.771-2.77V11.083a2.77 2.77 0 0 1 2.77-2.77h19a2.77 2.77 0 0 1 2.772 2.77z"
  })));
};
export default SvgDeviceLaptop;